import { TileAsset } from "../components/game-animations/game-animations.component";

export type TileVisualState = "idle" | "hover" | "pressed" | "loading" | "revealed" | "flipping";

export interface Tile {
  index: number;
  row: number;
  col: number;
  x: number;
  y: number;
  w: number;
  h: number;
  state: TileVisualState;
  asset?: TileAsset;
  flipScaleX: number;
  flipPhase: "none" | "out" | "in";
}

export interface CellState {
  index: number;
  state: TileVisualState;
}
